// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2Bg8J","paramInput":"JobSimulator_paramInput__3nuT5","input":"JobSimulator_input__11xhV"};